"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[9089],{

/***/ 7610
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export MiniStepperController */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class MiniStepperController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    'copy',
    'badgesContainer',
    'progressBar',
    'progressBarContainer',
  ]
  static values = {
    steps: { type: Array, default: [] },
    percentage: { type: Number, default: 0 },
  }

  setSteps(event) {
    this.stepsValue = event.detail.steps.filter(step => step.shouldRender)
  }

  setPercentage(event) {
    this.percentageValue = event.detail.percentage
  }

  stepsValueChanged() {
    this.updateStepper()
  }

  percentageValueChanged() {
    this.updateProgressBar()
  }

  updateStepper() {
    // If no steps are present, do nothing
    if (this.stepsValue.length === 0) { return }

    this.badgesContainerTarget.innerHTML = ''
    const nextUnmetStep = this.stepsValue.find(step => !step.met)
    if (nextUnmetStep) {
      // There's a step ahead to reach, show that
      this.copyTarget.innerHTML = nextUnmetStep.renderedCopyWhenUnmet
      const stepElement = document.getElementById(nextUnmetStep.id)
      if(!stepElement) { return }
      
      const indicator = stepElement.querySelector('.step-indicator').cloneNode(true)
      this.badgesContainerTarget.appendChild(indicator)
      this.progressBarContainerTarget.classList.remove('hidden')
    } else {
      // No more steps to reach, show all badges
      const lastStep = this.stepsValue.at(-1)
      this.copyTarget.innerHTML = lastStep.renderedCopyWhenMet
      this.progressBarContainerTarget.classList.add('hidden')
      this.stepsValue.forEach(step => {
        const stepElement = document.getElementById(step.id)
        if(!stepElement) { return }
        
        const indicator = stepElement.querySelector('.step-indicator').cloneNode(true)
        this.badgesContainerTarget.appendChild(indicator)
      })
    }
  }

  updateProgressBar() {
    if (this.stepsValue.length === 0) { return }

    const lastMetStepIndex = this.stepsValue.findIndex(step => !step.met)
    // If there's no index, it means we have met all of the steps, progress bar is hidden
    if (lastMetStepIndex === -1) { return }

    const progressPerStep = 100 / this.stepsValue.length
    const progressWithinCurrentStep = (this.percentageValue - (lastMetStepIndex * progressPerStep)) / progressPerStep * 100
    const currentStepProgress = Math.max(0, Math.min(progressWithinCurrentStep, 100))

    this.progressBarTarget.style.width = `${currentStepProgress}%`
  }
}

Stimulus.register("mini-stepper", MiniStepperController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(7610)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);